module.exports = __webpack_public_path__ + "static/media/wallpaper1.2604b599.webp";